import { resolveABVariantAPI } from "../query";

export interface ABVariantPayload {
  id: string | number;
  experimentName: string;
  [key: string]: any;
}

export default async function resolveABVariant(
  payload: ABVariantPayload,
  variantList: string[],
  successFn: () => void,
  failFn: () => void,
): Promise<void> {
  const now = Date.now();
  const raw = localStorage.getItem(payload.experimentName);
  const cached = raw ? JSON.parse(raw) : null;

  if (cached?.expiry > now && cached?.id === payload.id) {
    if (cached?.value && variantList.includes(cached.value)) {
      successFn();
    } else {
      failFn();
    }
    return;
  }

  try {
    const data = await resolveABVariantAPI<any>({
      experimentName: payload.experimentName,
      id: String(payload.id),
    });

    if (data?.status === 200) {
      const variant = data?.variantName;
      const toStore = {
        value: variant,
        id: payload.id,
        expiry: now + 86_400_000,
      };
      localStorage.setItem(payload.experimentName, JSON.stringify(toStore));

      if (variant && variantList.includes(variant)) {
        successFn();
      } else {
        failFn();
      }
    } else {
      failFn();
    }
  } catch (err) {
    console.error("resolveABVariantAPI error", err);
    failFn();
  }
}
